import { t } from "i18next";

export enum NutritionObjectives {
  Health = "health",
  Definition = "definition",
  Hypertrophy = "hypertrophy",
}

export const nutritionObjectiveOptions = [
  {
    id: 1,
    key: NutritionObjectives.Health,
    name: t(`contexts.training.objective_${NutritionObjectives.Health}`),
    text: "Entrenamiento saludable compensatorio",
    value: NutritionObjectives.Health,
  },
  {
    id: 2,
    key: NutritionObjectives.Definition,
    name: t(`contexts.training.objective_${NutritionObjectives.Definition}`),
    text: "Pérdida de tejido graso",
    value: NutritionObjectives.Definition,
  },
  {
    id: 3,
    key: NutritionObjectives.Hypertrophy,
    name: t(`contexts.training.objective_${NutritionObjectives.Hypertrophy}`),
    text: "Incremento de masa muscular",
    value: NutritionObjectives.Hypertrophy,
  },
];
